import { useLazyQuery, useMutation } from '@apollo/client'
import {
    ShowGlobalSnackbarMutation,
    ShowGlobalSnackbarMutationProps,
    ShowGlobalSnackbarRequest,
} from '@deltek/specification-client/core/Configurations/GlobalSnackbar'
import { ProductListingDetailsAutoSuggestQuery } from 'bpm/api/graphQL/queries/productSearch.queries'
import { ProductListingDetailsAutoSuggestResult } from 'bpm/api/graphQL/types/product.types'
import React, { FC } from 'react'
import ExistingFamilyAutoCompleteInput from './ExistingFamilyAutoCompleteInput'

const FamilySection: FC = () => {
    const [showGlobalSnackbar] = useMutation<
        ShowGlobalSnackbarRequest,
        ShowGlobalSnackbarMutationProps
    >(ShowGlobalSnackbarMutation)

    const [
        callAutoSuggest,
        { loading: autoSuggestLoading, data: autoSuggestData },
    ] = useLazyQuery<ProductListingDetailsAutoSuggestResult>(
        ProductListingDetailsAutoSuggestQuery,
        {
            fetchPolicy: 'network-only',
            onError: () => {
                showGlobalSnackbar({
                    variables: {
                        message: 'Something went wrong with autosuggest',
                        variant: 'error',
                        id: 'autosuggest_Error',
                    },
                })
            },
        }
    )

    return (
        <ExistingFamilyAutoCompleteInput
            autoSuggestData={autoSuggestData}
            callAutoSuggest={callAutoSuggest}
            autoSuggestLoading={autoSuggestLoading}
        />
    )
}

export default FamilySection
